import { selectorFamily } from 'recoil';
import { ShareInfoModel } from './typing';
import { shareInfo } from '@/utils/api';
import { activityId } from '@/App';

export type ShareInfoProps = {
  answer_log_id: string;
  achieve_id: string;
  questionnaire_id: string;
};

export const fetchShareInfoState = selectorFamily<ShareInfoModel, ShareInfoProps>({
  key: 'fetchShareInfoState',
  get: (props) => async ({ get }) => {
    const [e, r] = await shareInfo<ShareInfoModel>({
      ...props,
      aid: get(activityId),
    });
    if (r !== undefined) {
      return r.data;
    }
    if (e !== undefined) {
      throw new Error(e.data.msg as string);
    }
    throw new Error('数据异常');
  },
});
